<div class="table-wrapper" [ngClass]="'table-align-' + (block().table_align || 'left')">
  <table [class.has-borders]="block().has_borders" [style.min-width.px]="tableMinWidth()">
    <tbody>
      @for (row of processedRows(); track $index) {
        <tr>
          @for (cell of row.cells; track $index) {
            @if (cell.is_header) {
              <th
                [attr.colspan]="cell.colspan"
                [attr.rowspan]="cell.rowspan"
                [ngStyle]="cell.styles"
                [ngClass]="cell.classes"
              >
                <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: cell.content }" />
              </th>
            } @else {
              <td
                [attr.colspan]="cell.colspan"
                [attr.rowspan]="cell.rowspan"
                [ngStyle]="cell.styles"
                [ngClass]="cell.classes"
              >
                <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: cell.content }" />
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
</div>
